import { TInitialState } from '../reducer';

export const getAgreementId = (state: TInitialState) => {
    return state.agreement.agreementId;
};
